import { Box, Grid } from '@mui/material';
import { Settings } from '@/data/Settings';
import { ID } from '@/data/types/Basic';
import { footerTopSX, footerContainerSX } from '@/components/content/Footer/styles/general';
import { CopyrightDesktop } from '@/components/content/Footer/parts/CopyrightDesktop';
import { CallCenterDesktop } from '@/components/content/Footer/parts/CallCenterDesktop';
import { Promotions } from '@/components/content/Footer/parts/Promotions';
import { DpContainer } from '@/components/blocks/DpContainer';
import { FooterLinksDesktop } from '@/components/content/Footer/parts/Links';

export const FooterDesktop: React.FC<{
	id: ID;
	settings: Settings;
}> = ({ settings }) => (
	<Box component="footer">
		<DpContainer withoutmargin framesx={footerContainerSX(settings?.csrSession)}>
			<Grid container display="flex" justifyContent="center">
				<Grid item container spacing={'4px'} sx={footerTopSX} wrap="wrap">
					<Grid
						item
						sm={3}
						md={3}
						lg={3}
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'space-between',
						}}
					>
						<Promotions />
					</Grid>
					<FooterLinksDesktop />
					<Grid item sm={12} md={12} lg={3}>
						<CallCenterDesktop />
					</Grid>
				</Grid>
			</Grid>
		</DpContainer>
		<CopyrightDesktop />
	</Box>
);
